import { dbRef } from "../../db-ref";
import { ResourceSubPipeline } from "../../utils";
import { getUserSnippetPipeline } from "../users/user-snippet-resource";
import { zCart } from "./cart-resource";

function getCartItemsPipeline(): ResourceSubPipeline {
  const serviceUserSnippetPipeline = getUserSnippetPipeline(
    "cartItems.serviceDoc.userId",
    "cartItems.serviceDoc.userDoc",
  );

  return {
    mainStages: [
      {
        $unwind: {
          path: "$cartItems",
          preserveNullAndEmptyArrays: true,
        },
      },
      {
        $lookup: {
          from: dbRef.service.collection,
          localField: "cartItems.serviceId",
          foreignField: "_id",
          as: "cartItems.serviceDoc",
        },
      },
      {
        $unwind: {
          path: "$cartItems.serviceDoc",
          preserveNullAndEmptyArrays: true,
        },
      },
      {
        $addFields: {
          "cartItems.packageDoc": {
            $filter: {
              input: "$cartItems.serviceDoc.priceAndPackages",
              as: "package",
              cond: { $eq: ["$$package._id", "$cartItems.packageId"] },
            },
          },
        },
      },
      {
        $unwind: {
          path: "$cartItems.packageDoc",
          preserveNullAndEmptyArrays: true,
        },
      },
      ...serviceUserSnippetPipeline.mainStages,
      {
        $project: {
          "cartItems.itemTotal": 1,
          "cartItems.serviceDoc._id": 1,
          "cartItems.serviceDoc.title": 1,
          "cartItems.serviceDoc.images": 1,

          // this extra $project before $group is needed to populate each serviceDoc.userDoc individually
          ...serviceUserSnippetPipeline.projectStage,

          "cartItems.packageDoc._id": 1,
          "cartItems.packageDoc.name": 1,
          "cartItems.packageDoc.description": 1,
          "cartItems.packageDoc.requiredDays": 1,
          "cartItems.packageDoc.extraServices": 1,
          "cartItems.packageDoc.price": 1,
        },
      },
      {
        $group: {
          _id: "$_id",
          cartItems: { $push: "$cartItems" },
          // Add other fields you want to preserve from the original document
          // For example:
          // userId: { $first: "$userId" },
          // createdAt: { $first: "$createdAt" },
        },
      },
    ],
    projectStage: {
      "cartItems.itemTotal": 1,
      "cartItems.serviceDoc": 1,
      "cartItems.packageDoc": 1,
      "cartItems.tax": 1,
    },
  };
}

export function getCartPipelines() {
  const servicePipeline = getCartItemsPipeline();

  return {
    _z: zCart,
    mainStages: [...servicePipeline.mainStages],
    projectStage: {
      _id: 1,
      ...servicePipeline.projectStage,
    },
  };
}
